import React from 'react';
import { useUploadDocumentModal } from './use-upload-document-modal';
import { useForm } from 'react-hook-form';
import { Button, Flex, Text } from 'common/common-components.styled';
import FormHook from 'components/form-hook/form-hook';
import { UploadDocumentModalProps } from './upload-document-modal.types';

const UploadDocumentModal: React.FC<UploadDocumentModalProps> = ({
  documentType,
  taskId,
  files,
  isManagment,
  onClose,
  refetch
}) => {
  const reactHookFormData = useForm();
  const { formFields, onSubmit } = useUploadDocumentModal(reactHookFormData, taskId, files, isManagment, refetch);

  return (
    <Flex direction='column'>
      <Text bottom='20'>
        Bitte laden Sie ein Dokument mit dem Typ „<strong>{documentType}</strong>“ hoch. Optional können Sie unten einen
        Hinweis hinterlassen.
      </Text>

      <FormHook reactHookFormData={reactHookFormData} formFields={formFields} />

      <Flex justify='flex-end'>
        <Flex gap='10px'>
          <Button secondary onClick={onClose}>
            Abbrechen
          </Button>
          <Button onClick={onSubmit}>Hochladen</Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default UploadDocumentModal;
